import styled from 'styled-components';

const ShareButtonBarContainer = styled.div`
  display: flex;
  gap: 12px;
`;

export default ShareButtonBarContainer;
